<ul class="list-thumbnail search-result-view-list-thumbnail h-full">
  <cdk-virtual-scroll-viewport
    itemSize="122"
    class="scroll-viewport-height"
    [ngClass]="{'folder': searchContainer.currentPathView.search_view.search_view_type === 'folder',
                'open': searchContainer.isFolderInfoOpen}"
  >
    <ng-container *cdkVirtualFor="let art of ds">
      @if (!art) {
        <ng-container>
          <li class="search-result-view-list-thumbnail__loading-search-object"></li>
        </ng-container>
      }
      @else {
        <ng-container>
          <li class="list-thumbnail__frame-and-shadow">
            <div
              class="list-thumbnail__item"
              [ngClass]="{'border-blue': searchContainer.selections.selected[art.artifact_id]}"
            >
              <div class="list-thumbnail__row search-result-view-list-thumbnail__row">
                <div
                  class="list-thumbnail__first-container"
                  [ngClass]="{'folder': art.object_type === 'folder'}"
                >
                  <div class="checkbox-underlay">
                    <span
                      class="checkbox-tooltip-wrapper"
                      [class.cursor-not-allowed]="isCheckboxDisabled(art) && !art.$$used"
                      [matTooltip]="isCheckboxDisabled(art) && !art.$$used ? ('TRANS__SEARCH_SELECTIONS__TOO_MANY_SELECTED' | translate) : ''"
                    >
                      <label class="custom-checkbox-container">
                        <input
                          type="checkbox"
                          [checked]="searchContainer.selections.selected[art.artifact_id]"
                          [disabled]="isCheckboxDisabled(art)"
                          (click)="select(art, $event)"
                          (keydown)="null"
                        >

                        <span class="ripple"></span>

                        <span class="checkmark"></span>
                      </label>
                    </span>
                  </div>

                  @if (art.has_authority) {
                    <div class="authority-ribbon-container">
                      <div
                        class="authority-ribbon"
                        [ngClass]="{'situla': art.authority_id === clientConfig.AUTHORITY_ARCHAEOLOGY_ID,
                                    'ribbon-kultur-nav': art.authority_id === clientConfig.AUTHORITY_KULTURNAV_ID}"
                      >
                        <span>
                          {{art.authority_id_value}}
                        </span>
                      </div>
                    </div>
                  }

                  <a
                    [routerLink]="getRouterLink(art)"
                    [queryParams]="art.$$refData?.queryParams"
                    queryParamsHandling="merge"
                    (click)="setSearchItemIndex(art.$$refData.param['searchItemIndex'], $event)"
                    class="thumbnail-url"
                  >
                    @if (art.$$imageUrl) {
                      <img
                        alt="{{art.artifact_name}}"
                        [src]="art.$$imageUrl"
                        class="thumbnail-fixed-height"
                      >
                    }
                    @else {
                      <i
                        class="{{art.$$noImageIcon}} imgIcon"
                        [ngClass]="{'text-blue': art.object_type === 'folder'}"
                      ></i>

                      @if (art['$$folderItemCount']) {
                        <span class="text-blue search-result-view-list-thumbnail__folder-items">
                          {{art['$$folderItemCount']}}
                        </span>
                      }
                    }
                  </a>
                </div>

                <div
                  class="list-thumbnail__second-container"
                  [ngClass]="{'no-image': !art.$$imageUrl}"
                >
                  <a
                    [routerLink]="getRouterLink(art)"
                    [queryParams]="art.$$refData?.queryParams"
                    queryParamsHandling="merge"
                    (click)="setSearchItemIndex(art.$$refData.param['searchItemIndex'], $event)"
                    class="list-overview-fields__headline"
                  >
                    <h2 class="object-url-content">
                      <i
                        class="list-item-icon object-icon {{art.$$icon}}"
                        [class.text-blue]="art.meta_type === MetaTypes.ADM_EVENT"
                      ></i>

                      <span
                        class="bold list-overview-fields__headline-text search-result-overview-fields__headline-text text-link"
                        [innerHTML]="art.artifact_name"
                      ></span>
                    </h2>
                  </a>

                  <app-search-columns-overview-fields
                    (click)="setSearchItemIndex(art.$$refData.param['searchItemIndex'], $event)"
                    class="list-thumbnail__object-overview overview-fields__content-list"
                    [constrainHeight]="false"
                    [enableCollapsibleFields]="false"
                    [hideHeadline]="true"
                    [searchObject]="art"
                    [viewName]="searchContainer.searchResultViewName"
                  ></app-search-columns-overview-fields>
                </div>
              </div>
            </div>
          </li>
        </ng-container>
      }
    </ng-container>
  </cdk-virtual-scroll-viewport>
</ul>
